let cachedSuggestions = null;
let inflightRequest = null;

const parseSuggestions = (text) =>
    text
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);

export const getAttributeSuggestions = async () => {
    if (cachedSuggestions) return cachedSuggestions;
    if (!inflightRequest) {
        const url = `${process.env.PUBLIC_URL}/attributes.txt`;
        inflightRequest = fetch(url)
            .then((response) => (response.ok ? response.text() : ""))
            .then((text) => {
                cachedSuggestions = parseSuggestions(text);
                return cachedSuggestions;
            })
            .catch(() => {
                cachedSuggestions = [];
                return cachedSuggestions;
            });
    }
    return inflightRequest;
};
